import "./Panels.css";
import { images } from '../../shared/assets';
import { useTranslation } from 'react-i18next';

// Frame 5: Outro
const OutroPanel: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="outro">
      <div className="outro__text" dangerouslySetInnerHTML={{ __html: t('pages/home:carousel.outro.text') }} />
      <div className="outro__image">
        <img
          src={images.galleryPage.figma.image1}
          alt="Atacama landscape"
        />
      </div>
    </div>
  );
};

export default OutroPanel;